export function convertToEnglish(number) {
    const persianDigits = {
        '۰': '0',
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9'
    };

    return number.replace(/[۰-۹]/g, digit => persianDigits[digit]);
}
export function convertToPersian(number) {
    const EnglishDigits = {
        '0' : '۰',
        '1' : '۱',
        '2' : '۲',
        '3' : '۳',
        '4' : '۴',
        '5' : '۵',
        '6' : '۶',
        '7' : '۷',
        '8' : '۸',
        '9' : '۹'
    };

    return number.replace(/[0-9]/g, digit => EnglishDigits[digit]);
}
export function numberFormat(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function removeCommos(x) {
    return x.replaceAll(',','');
}